import axios from 'axios';
import { API_BASE, getHeaders } from '../../config/api';

const BASE_URL = `${API_BASE}/api/superAdmin/complaintType`;

const getAuthToken = () =>
    sessionStorage.getItem('adminToken') ||
    sessionStorage.getItem('subAdminToken') ||
    '';

const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: getHeaders(),
});

apiClient.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


export const fetchUserQueries = async (status = 'All') => {
    const response = await apiClient.get('/get-user-queries', {
        params: { status },
    });
    return response.data;
};

export const updateUserQuery = async ({ id, status, reply }) => {
    const payload = { id, status };
    if (reply !== undefined) payload.reply = reply;

    const response = await apiClient.put('/update-user-query', payload);
    return response.data;
};

export const deleteUserQuery = async (id) => {
    const response = await apiClient.delete(`/delete-user-support/${id}`);
    return response.data;
};


export const fetchMasterQueries = async (status = 'All') => {
    const response = await apiClient.get('/get-master-queries', {
        params: { status },
    });
    return response.data;
};

export const updateMasterQuery = async ({ id, status, reply }) => {
    const payload = { id, status };
    if (reply !== undefined) payload.reply = reply;

    const response = await apiClient.put('/update-master-query', payload);
    return response.data;
};

export const deleteMasterQuery = async (id) => {
    const response = await apiClient.delete(`/delete-master-support/${id}`);
    return response.data;
};


export const STATUS_API_TO_LABEL = {
    pending: 'Pending',
    inprogress: 'In Progress',
    solved: 'Resolved',
};

export const STATUS_LABEL_TO_API = {
    Pending: 'pending',
    'In Progress': 'inprogress',
    Resolved: 'solved',
};

export const STATUS_OPTIONS = ['Pending', 'In Progress', 'Resolved'];

export const formatTimeAgo = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const diffMs = Date.now() - date.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    if (diffSec < 60) return 'just now';
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin} min ago`;
    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) return `${diffHr} hour${diffHr > 1 ? 's' : ''} ago`;
    const diffDay = Math.floor(diffHr / 24);
    if (diffDay < 30) return `${diffDay} day${diffDay > 1 ? 's' : ''} ago`;
    return date.toLocaleDateString();
};


export const mapComplaint = (item) => ({
    id: item._id,
    ticketId: item.ticketId,
    title: item.title,
    description: item.description,
    user: (item.userName || 'Unknown User').trim(),
    image: item.image || null,
    reply: item.reply || '',
    reason: item.reason || '',
    status: STATUS_API_TO_LABEL[item.status] || item.status,
    apiStatus: item.status,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
    time: formatTimeAgo(item.createdAt),
});